// extracted by mini-css-extract-plugin
export default {"container":"agckh4","shadow":"bgckh4"};